import { observable } from "mobx";
import { Type } from "class-transformer";
import VehicleDetailAccessActionResponse from "./vehicleDetailAccessActionResponse";
import VehicleSynchronizationActionResponse from "./vehicleSynchronizationActionResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class VehicleRegisterVehiclePermittedActionsResponse {
  @observable
  @Type(() => VehicleDetailAccessActionResponse)
  vehicleDetailAccess!: VehicleDetailAccessActionResponse;

  @observable
  @Type(() => VehicleSynchronizationActionResponse)
  vehicleSynchronization!: VehicleSynchronizationActionResponse;
}
